import { render, staticRenderFns } from "./GjwDialog.vue?vue&type=template&id=ed8c37e8&scoped=true&"
import script from "./GjwDialog.vue?vue&type=script&lang=js&"
export * from "./GjwDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8c37e8",
  null
  
)

export default component.exports